import { SessionOverride } from '@optools/services/operator-gateway/overrides/session/types';
import { ClientType } from '@optools/services/operator-gateway/overrides/types';
import {
  SessionFeature,
  SessionOverridesQuery,
} from '@optools/services/operator-gateway/types/generated/graphql';

export function transformSessionOverride(
  override: SessionOverridesQuery['sessionOverrides'][number],
): SessionOverride {
  const { features, id, matchParams } = override;
  const { clientType = ClientType.ALL_CLIENTS, userId = '' } = matchParams;
  return { clientType, features: features as SessionFeature[], id, userId };
}
